import React from "react";
import { Link, useNavigate } from "react-router-dom";
import dubai1 from "../assets/places/dubai/dubai13.jpg";
import dubai2 from "../assets/places/dubai/dubai1.jpg";
import bali6 from "../assets/places/bali/bali6.jpg";
import singapur13 from "../assets/places/singapur/singapur13.jpg";
import banner from "../assets/places/paris/thailand9.jpg";

const blogsData = [
  {
    id: 4,
    image: dubai2,
    date: "2024-12-01",
    title:
      " Best 10 International Destinations for a Magical New Year’s Eve Getaway",
    description:
      "As the year comes to an end, it’s time to plan the perfect New Year’s Eve getaway.",
    author: "Diksha",
  },
  {
    id: 1,
    image: bali6,
    date: "2024-12-01",
    title: "Exploring the Beauty of Bali",
    description:
      "Discover the breathtaking landscapes and vibrant culture of Bali in this comprehensive travel guide.",
    author: "Unknown",
  },
  {
    id: 2,
    image: dubai1,
    date: "2024-12-02",
    title: "The Wonders of Dubai",
    description:
      "Experience the grandeur and modern marvels of Dubai with our ultimate travel guide.",
    author: "Unknown",
  },
  {
    id: 3,
    image: singapur13,
    date: "2024-12-03",
    title: "Singapore: A City of the Future",
    description:
      "Explore the futuristic cityscape and rich heritage of Singapore in our detailed travel blog.",
    author: "Diksha",
  },
  // Add more blog data as needed
];
const slugify = (title) =>
  title
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");

const BlogsNew = () => {
  const navigate = useNavigate();
  return (
    <div className=" mx-auto pb-20 dark:bg-gray-900 bg-white text-black dark:text-white">
      {/* Banner Section */}
      <div className="relative mt-10 mb-10">
        <img
          src={banner}
          alt="Travel Banner"
          className="w-full h-96 object-cover rounded-lg shadow-lg"
        />
        <div className=" relative top-4 flex items-center justify-center">
          <h1 className="text-4xl text-[#5b53fb] font-bold">Travel Blogs</h1>
        </div>
      </div>

      {/* Blogs Section */}
      <div className="grid grid-cols-1 mb-4 xl:px-32 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogsData.map((blog) => (
          <Link
            to={`/blogsdetails/${slugify(blog.title)}`}
            // onClick={() => navigate(`/blogsdetails/${slugify(blog.title)}`)}
            key={blog.id}
            className="dark:bg-gray-800 bg-white text-black rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition duration-300 transform hover:-translate-y-1"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <p className="text-gray-900 dark:text-white text-sm">
                {blog.date}
              </p>
              <h2 className="text-xl font-semibold text-indigo-500 mt-2">
                {blog.title}
              </h2>
              <p className="text-gray-900 dark:text-white mt-2">
                {blog.description}
              </p>
              <p className="text-gray-700 dark:text-white text-sm mt-4">
                by {blog.author}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogsNew;
